import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

/** English and Mexico Spanish only. Isaac, 2026-10-09: no Chinese anywhere in the app
 * (a deliberate deviation from MI stack §10's trilingual rule). */
export const SUPPORTED_LANGUAGES = ["en", "es-MX"] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<Language, string> = {
  en: "English",
  "es-MX": "Español (MX)",
};

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: [
      "common",
      "auth",
      "navigation",
      "inventory",
      "marketplaces",
      "advertising",
      "sales",
      "designs",
      "invoices",
      "gac",
      "settings",
      "assistant",
      "alerts",
      "import",
    ],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
